// Client Book: accounts. "Add portfolio" on the Desk client record
// (`wealth.crm.client-book.accounts`, ADR-0027). The IM adds a portfolio to an
// account of the client, so the button shows only when the client has one.
import { lazy } from 'react';
import { defineWebFeature } from '@/features/kit';

const AddPortfolioAction = lazy(() =>
    import('./client-book.slots').then((m) => ({ default: m.AddPortfolioAction })),
);

export default defineWebFeature({
    id: 'wealth.crm.client-book.accounts',
    slots: {
        'client.detail.accounts-actions': [
            {
                key: 'add-portfolio',
                order: 10,
                when: (ctx) => ctx.view === 'desk' && ctx.detail.accounts.length > 0,
                Component: AddPortfolioAction,
            },
        ],
    },
});
